/**
 * Gerenciador de Estado Reativo — STELLARI SERVE
 */

import { STORE_INFO } from '../data/menuData.js';

const STORAGE_KEY = 'stellari_serve_cart_v1';

class Store {
  constructor() {
    this.currentView = 'home'; // 'home' | 'category' | 'product' | 'jantinha' | 'cart' | 'checkout'
    this.activeCategoryId = null;
    this.activeProduct = null;
    this.editingCartItemId = null;
    this.categorySearchQuery = '';
    
    // Recupera carrinho do localStorage se existir
    this.cart = this.loadCart();
    this.listeners = [];
  }

  loadCart() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      return [];
    }
  }

  saveCart() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.cart));
    } catch (e) {
      console.warn("Falha ao salvar carrinho no localStorage:", e);
    }
  }

  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  notify() {
    this.saveCart();
    this.listeners.forEach(fn => fn(this));
  }

  setView(view, params = {}) {
    this.currentView = view;
    if (params.categoryId !== undefined) {
      this.activeCategoryId = params.categoryId;
      this.categorySearchQuery = '';
    }
    if (params.product !== undefined) {
      this.activeProduct = params.product;
    }
    if (params.editingCartItemId !== undefined) {
      this.editingCartItemId = params.editingCartItemId;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.notify();
  }

  setCategorySearch(query) {
    this.categorySearchQuery = query;
    this.notify();
  }

  addToCart(item) {
    const cartItemId = item.cartItemId || 'item_' + Date.now() + '_' + Math.random().toString(36).substr(2, 4);
    
    if (this.editingCartItemId) {
      // Atualizando item existente
      const index = this.cart.findIndex(i => i.cartItemId === this.editingCartItemId);
      if (index !== -1) {
        this.cart[index] = { ...item, cartItemId: this.editingCartItemId };
      } else {
        this.cart.push({ ...item, cartItemId });
      }
      this.editingCartItemId = null;
    } else {
      this.cart.push({ ...item, cartItemId });
    }

    this.notify();
  }

  updateItemQuantity(cartItemId, delta) {
    const item = this.cart.find(i => i.cartItemId === cartItemId);
    if (!item) return;

    item.quantity += delta;
    if (item.quantity <= 0) {
      this.removeFromCart(cartItemId);
    } else {
      // Recalcula valor total do item
      if (!item.pricePending) {
        item.totalPrice = Number((item.unitPrice * item.quantity).toFixed(2));
      }
      this.notify();
    }
  }

  removeFromCart(cartItemId) {
    this.cart = this.cart.filter(i => i.cartItemId !== cartItemId);
    this.notify();
  }

  clearCart() {
    this.cart = [];
    this.notify();
  }

  getItemCount() {
    return this.cart.reduce((total, item) => total + item.quantity, 0);
  }

  getSubtotal() {
    return this.cart.reduce((acc, item) => {
      if (item.pricePending || !item.totalPrice) return acc;
      return acc + item.totalPrice;
    }, 0);
  }

  getDeliveryFee() {
    return STORE_INFO.deliveryFee; // null (A DEFINIR)
  }

  getTotal() {
    const subtotal = this.getSubtotal();
    const fee = this.getDeliveryFee() || 0;
    return Number((subtotal + fee).toFixed(2));
  }
}

export const store = new Store();
